import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AreaService } from 'src/app/arealist.service';
import { CommonService, PropertyMeasurement } from 'src/app/Shared/Common/common.service';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';

declare var $: any;

@Component({
  selector: 'app-user-network-post-list',
  templateUrl: './user-network-post-list.component.html',
  styleUrls: ['./user-network-post-list.component.css']
})
export class UserNetworkPostListComponent implements OnInit {

  @Input() PortalType: string = 'Mobile';
  isLoader: boolean = false;
  authData: any;
  userProfileInfo: any;
  areasList: any[] = [];
  arrList: any[] = [];
  selectedAreasID: any = [];
  usersList: any = [];

  searchInput: string = '';

  constructor(private uPostCommonService: CommonService, private uPostsPropertyService: PropertyPostsService,
    private userPropRouter: Router, private areaService: AreaService) {
    this.areasList = this.areaService.getAreas();
  }

  ngOnInit() {
    this.authData = localStorage.getItem('authData') == undefined ? '' : JSON.parse(localStorage.getItem('authData'));
    this.userProfileInfo = localStorage.getItem('authProfileData') == undefined ? '' : JSON.parse(localStorage.getItem('authProfileData'));
    if (this.authData == '') {
      this.uPostCommonService.CallToster('E', 'Invalid user authencation, Please re-login...!');
      setTimeout(() => {
        this.userPropRouter.navigate(['/m']);
      }, 1000);
      this.areasList = this.areaService.getAreas();
    }
    //this.LoadUsersList();
  }

  searchUsers() {
    if (this.searchInput.length > 2) {
      this.usersList = this.usersList.filter(user =>
        user.CustomerName.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    } else {
      // If search input is less than 3 characters, reset the user list
      this.LoadUsersList();
    }
  }

  LoadUsersList() {
    try {
      this.isLoader = true;
      document.getElementById('txt-search').innerText = '';
      this.arrList = [];
      let strArs = '';
      this.selectedAreasID.forEach((ars) => {
        strArs = ars.AreaID + ',';
      });
      this.uPostsPropertyService.GetPropertyCustomerList(this.authData.UserID, strArs).subscribe(res => {
        this.isLoader = false;
        if (res.status == 1) {
          let usersList = res.body;

          // Cache the UsersList
          //localStorage.setItem(cachedUsersListKey, JSON.stringify(usersList));

          // Set cache expiration time to 5 minutes from now
          //const expirationTime = Date.now() + 5 * 60 * 1000;
          //localStorage.setItem(cacheExpirationKey, expirationTime.toString());

          this.usersList = usersList;
        }
      }, err => {
        this.isLoader = false;
        // Handle errors
      });

    } catch (error) {
      this.isLoader = false;
      // Handle errors
    }
  }


  doSearch(eve: any): void {
    if (eve.target.value.length > 2) {
      this.arrList = this.areasList.filter(function (x) {
        return x.AreaName.toLowerCase().indexOf(eve.target.value.toLowerCase()) > -1;
      });
    }
    else {
      this.arrList = [];
    }
  }

  addPreferredAreas(event: any, arr: any) {
    if (event.target.checked) {
      //console.log('Checked');
      this.selectedAreasID.push(arr);
    }
    else {
      //console.log('UnChecked');
      this.selectedAreasID = this.selectedAreasID.filter((item) => {
        if (item.AreaID != arr.AreaID)
          return item;
      });
    }
  }

  removePreferredAreas(arr: any) {
    this.selectedAreasID = this.selectedAreasID.filter((item) => {
      if (item.AreaID != arr.AreaID)
        return item;
    });
  }

  ReturnPreferredAreasNames(strars: string): string {
    //console.log(JSON.parse(strars));
    let arsList = [] = JSON.parse(strars);
    let strNames = '';
    arsList.forEach(element => {
      strNames += element.AreaName + ', '
    });
    return (strNames.substring(0, strNames.length - 2)).toUpperCase();
  }

  ReturnPropertyMeasure(strM: string, unit: number): string {
    let strMeasure = '';
    PropertyMeasurement.forEach(element => {
      if (element.Id == unit)
        strMeasure = element.Name;
    });
    return strM + " " + strMeasure;
  }

  gotoProfilePage() {
    this.userPropRouter.navigate(['/m/myprofile']);
  }

  gotoUserPostPage(userInfo: any) {
    //console.log(userInfo);
    if (this.PortalType == 'Mobile')
      this.userPropRouter.navigate(['/m/viewposts'], { queryParams: { page: this.uPostCommonService.encryptData(JSON.stringify(userInfo)) } });
    else
      this.userPropRouter.navigate(['/viewposts'], { queryParams: { page: this.uPostCommonService.encryptData(JSON.stringify(userInfo)) } });
  }

}